<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>服务列表</p>
    </div>
    <div class="main-body">
      <el-row style="display: flex; margin-bottom: 20px;">
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="请输入服务名称"
          v-model="condition"
          clearable
        >
          <template slot="prepend"
            ><span class="el-icon-search"></span>
          </template>
        </el-input>
        <el-button class="w100" type="primary" @click="handleAudit"
          >审核</el-button
        >
        <el-button class="w100" type="primary" @click="handlePackage"
          >打包</el-button
        >
        <el-button class="w100" type="warning" @click="handlePublish(1)"
          >发布测试</el-button
        >
        <el-button class="w100" type="info" @click="handlePublish(2)"
          >发布灰度</el-button
        >
        <el-button class="w100" type="success" @click="handlePublish(3)"
          >发布正式</el-button
        >
        <el-button
          class="w150"
          type="success"
          @click="handleUploadDockerImage()"
          >上传docker镜像</el-button
        >
      </el-row>
      <el-table
        ref="singleTable"
        :data="recordList"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column property="typeDesc" label="服务类型"></el-table-column>
        <el-table-column property="name" label="服务名称"></el-table-column>
        <el-table-column
          property="className"
          label="服务类名"
        ></el-table-column>
        <el-table-column
          property="packagingTypeDesc"
          label="打包类型"
        ></el-table-column>
        <el-table-column
          property="mainClassFullName"
          label="服务主类全名"
        ></el-table-column>
        <el-table-column
          property="logbackFileName"
          label="日志文件名"
        ></el-table-column>
        <el-table-column
          property="packagePath"
          label="打包路径"
        ></el-table-column>
        <el-table-column
          property="projectName"
          label="工程名称"
        ></el-table-column>
        <el-table-column
          property="moduleName"
          label="模块名称"
        ></el-table-column>
      </el-table>
      <div style="padding: 10px">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="handlePageChange"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "serviceList",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      editRecord: null,
      loading: false,
      loadingText: "数据加载中，请稍候...",
      condition: "",
      total: 0,
      beginIndex: 0,
      pageSize: 10,
      timer: null,
    };
  },
  mounted() {
    this.queryRecordList();
  },
  watch: {
    condition() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.beginIndex = 0;
        this.queryRecordList();
      }, 500);
    },
  },
  methods: {
    handlePageChange(pageNum) {
      this.beginIndex = (pageNum - 1) * this.pageSize;
      this.queryRecordList();
    },

    handleCurrentChange(val) {
      this.editRecord = val || {};
    },

    operateValidate() {
      if (!this.editRecord) {
        this.$message({
          type: "warning",
          message: "请先选择一个服务",
          center: true,
        });
        return false;
      }
      return true;
    },

    handleAudit() {
      if (!this.operateValidate()) {
        return;
      }
      this.$router.replace(
        "/managePage/applyList?releaseStatus=10&taskId=" + this.editRecord.id
      );
    },

    handlePackage() {
      if (!this.operateValidate()) {
        return;
      }
      this.$router.replace(
        "/managePage/applyList?releaseStatus=20&taskId=" + this.editRecord.id
      );
    },

    handlePublish(env) {
      if (!this.operateValidate()) {
        return;
      }
      this.$router.replace(
        "/managePage/serviceInstanceList?env=" +
          env +
          "&taskId=" +
          this.editRecord.id +
          "&opt=1"
      );
    },

    handleUploadDockerImage() {
      if (!this.operateValidate()) {
        return;
      }
      this.$router.replace(
        "/managePage/serviceInstanceList?taskId=" +
          this.editRecord.id +
          "&opt=2"
      );
    },

    queryRecordList() {
      let self = this;
      self.loading = true;
      this.$http
        .get(
          "/admin/release/task/list?" +
            this.$qs.stringify({
              condition: this.condition,
              beginIndex: this.beginIndex,
              pageSize: this.pageSize,
            }),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
          self.total = res.mdata.total;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/serviceList.vue